import React, { useEffect, useState, useMemo } from "react";
import UsuariosTabela from "./UsuariosTabela";
import UsuariosFiltro from "./UsuariosFiltro";
import UsuarioFormModal from "./UsuarioFormModal.jsx";
import { UserPlus, User } from "lucide-react";
import { API_URL } from "../../config";
import quadroLogo from '../../images/logo/quadro.png';

function NovoUsuarioButton({ onClick }) {
  return (
    <button
      onClick={onClick}
      className="flex items-center justify-center sm:justify-start gap-2 bg-[#303357] hover:bg-[#2a2d4d] text-white font-semibold px-4 py-2 sm:px-5 shadow-md transition duration-200 transform hover:scale-105 w-full sm:w-auto"
    >
      <UserPlus size={18} />
      Novo Usuário
    </button>
  );
}

export default function Usuarios() {
  const [usuarios, setUsuarios] = useState([]);
  const [filtros, setFiltros] = useState({ codigo: "", nome: "", funcao: "" });
  const [modalAberto, setModalAberto] = useState(false);
  const [usuarioSendoEditado, setUsuarioSendoEditado] = useState(null);
  const [loading, setLoading] = useState(true);

  const carregarUsuarios = async () => {
    try {
      const res = await fetch(`${API_URL}/usuarios.php`);
      const data = await res.json();
      setUsuarios(data);
    } catch (error) {
      console.error("Erro ao carregar usuários:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarUsuarios();
    window.scrollTo(0, 0);
  }, []);

  const usuariosFiltrados = useMemo(() => {
    return usuarios.filter((usuario) =>
      (usuario.nome || "").toLowerCase().includes(filtros.nome.toLowerCase()) &&
      (usuario.funcao || "").toLowerCase().includes(filtros.funcao.toLowerCase()) &&
      usuario.codigo?.toString().includes(filtros.codigo)
    );
  }, [usuarios, filtros]);

  const abrirModalNovoUsuario = () => {
    setUsuarioSendoEditado(null);
    setModalAberto(true);
  };

  const abrirModalEdicaoUsuario = (usuario) => {
    setUsuarioSendoEditado(usuario);
    setModalAberto(true);
  };

  const fecharModal = () => {
    setModalAberto(false);
    setUsuarioSendoEditado(null);
  };

  return (
    <div className="min-h-screen w-full bg-[#f7f7f7] p-4 sm:p-6">
      <div className="max-w-full mx-auto">
        <div
          className="flex flex-wrap items-center space-x-2 text-sm text-black font-semibold mb-1"
          style={{ marginTop: "-60px", marginLeft: "10px" }}
        >
          <User size={23} className="text-gray-1500" />
          <span>Configurações / Cadastro / Usuários</span>
        </div>

        {/* Faixa escura com botão sem borda arredondada */}
        <div className="bg-[#05092a] py-2 px-4 flex flex-col sm:flex-row justify-between items-center gap-4 mt-4 mb-3 shadow-md border border-black">
          <NovoUsuarioButton onClick={abrirModalNovoUsuario} />
        </div>

        {/* Espaço entre faixa e quadro */}
        <div className="h-2"></div>

        {/* Quadro branco com tabela, sem borda arredondada */}
        <div className="bg-white border border-black shadow-lg p-4 sm:p-6 mb-6 overflow-x-auto">
          <UsuariosFiltro filtros={filtros} setFiltros={setFiltros} />

          {loading ? (
            <div>Carregando usuários...</div>
          ) : (
            <div className="overflow-x-auto">
              <UsuariosTabela
                usuarios={usuariosFiltrados}
                recarregar={carregarUsuarios}
                onEditar={abrirModalEdicaoUsuario}
              />
            </div>
          )}
        </div>

        {/* Modal */}
        <UsuarioFormModal
          isOpen={modalAberto}
          onClose={fecharModal}
          onSalvar={carregarUsuarios}
          usuario={usuarioSendoEditado}
          usuarios={usuarios}
        />
      </div>

      {/* Rodapé sem borda arredondada */}
      <div className="shadow-md p-4 bg-white mt-10 border border-[#1A2A36]">
        <div className="flex flex-col sm:flex-row items-center justify-start text-sm text-gray-600 gap-2 sm:gap-4">
          <p><strong>Sistema Web para controle de Chamados</strong></p>
          <span className="hidden sm:inline">/</span>
          <p><strong>Desenvolvido por: <span className="text-orange-600">Mega Sistem Informática</span></strong></p>
          <img src={quadroLogo} alt="Logo" className="h-8 mt-2 sm:mt-0 sm:ml-4" />
        </div>
      </div>
    </div>
  );
}
